<template>
  <b-card>
    <form method="post" action="" autocomplete="off">
      <div slot="header" class="mb-4">
        <strong>{{title}}</strong>
      </div>
      <div class="row">
        <div class="col-sm-4 mb-2">
          <strong>{{$t('BASICDATA')}}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3">
          <b-form-fieldset v-bind:label="$t('USERNAME')">
            <inputvalidation :formerror="formError" name="username"><b-form-input type="text" v-model="formData.username" v-bind:placeholder="$t('USERNAME')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-3">
          <b-form-fieldset v-bind:label="$t('PASSWORD')">
            <inputvalidation :formerror="formError" name="password"><b-form-input type="password" v-model="formData.password" v-bind:placeholder="$t('PASSWORD')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-3">
          <b-form-fieldset v-bind:label="$t('USEREMAIL')">
            <inputvalidation :formerror="formError" name="userEmail"><b-form-input type="email" v-model="formData.userEmail" v-bind:placeholder="$t('USEREMAIL')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-3" :class="(!newuser) ? 'col-sm-12' : ''">
          <b-form-fieldset v-bind:label="$t('STATUS')">
            <inputvalidation :formerror="formError" name="status"><b-form-select :options="status" v-model="formData.status"></b-form-select></inputvalidation>
          </b-form-fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6" v-if="!newuser">
          <b-form-fieldset v-bind:label="$t('USERGROUP')">
            <inputvalidation :formerror="formError" name="groupId"><b-form-select :options="aclGroups.root" v-model="formData.groupId" value-field="groupId" text-field="groupName"></b-form-select></inputvalidation>
          </b-form-fieldset>
        </div>

      </div>

      <div class="row">
        <div class="col-sm-4 mb-2">
          <strong>{{$t('ADDITIONALDATA')}}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <b-form-fieldset v-bind:label="$t('NAME')">
            <inputvalidation :formerror="formError" name="name"><b-form-input type="text" v-model="formData.name" v-bind:placeholder="$t('NAME')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-4">
          <b-form-fieldset v-bind:label="$t('SURNAME')">
            <inputvalidation :formerror="formError" name="surname"><b-form-input type="text" v-model="formData.surname" v-bind:placeholder="$t('SURNAME')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-4">
          <b-form-fieldset v-bind:label="$t('OIBNUM')">
            <inputvalidation :formerror="formError" name="oibNum"><b-form-input type="text" v-model="formData.oibNum" v-bind:placeholder="$t('OIBNUM')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3">
          <b-form-fieldset v-bind:label="$t('TITLE')">
            <inputvalidation :formerror="formError" name="title"><b-form-input type="text" v-model="formData.title" v-bind:placeholder="$t('TITLE')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-3">
          <b-form-fieldset v-bind:label="$t('PHONE')">
            <inputvalidation :formerror="formError" name="phone"><b-form-input type="text" v-model="formData.phone" v-bind:placeholder="$t('PHONE')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-3">
          <b-form-fieldset v-bind:label="$t('USERCOLOR')">
            <b-form-input v-model="formData.userColor" type="color"></b-form-input>
          </b-form-fieldset>
        </div>
        <div class="col-sm-3">
          <b-form-fieldset v-bind:label="$t('COMPANY')">
            <inputvalidation :formerror="formError" name="companyId">
              <lb-vue-select v-model= "formData.companyId"
                              :list= "company.root"
                              display-field= "companyName"
                              value-field= "companyId">
              </lb-vue-select>
            </inputvalidation>
          </b-form-fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3">
          <b-form-fieldset v-bind:label="$t('ADDRESS')">
            <inputvalidation :formerror="formError" name="address"><b-form-input type="text" v-model="formData.address" v-bind:placeholder="$t('ADDRESS')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-3">
          <b-form-fieldset v-bind:label="$t('CITY')">
            <inputvalidation :formerror="formError" name="city"><b-form-input type="text" v-model="formData.city" v-bind:placeholder="$t('CITY')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-3">
          <b-form-fieldset v-bind:label="$t('POSTALCODE')">
            <inputvalidation :formerror="formError" name="postalCode"><b-form-input type="text" v-model="formData.postalCode" v-bind:placeholder="$t('POSTALCODE')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-3">
          <b-form-fieldset v-bind:label="$t('COUNTRY')">
            <inputvalidation :formerror="formError" name="country"><b-form-input type="text" v-model="formData.country" v-bind:placeholder="$t('COUNTRY')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <p class="bg-danger" v-if="formError.error && typeof formError.notice == 'string'">{{formError.notice}}</p>
          <b-button type="submit" class="btn button-save" v-on:click.prevent="saveRow(formData)">{{$t('SUBMIT')}}</b-button>
        </div>
      </div>
    </form>
  </b-card>
</template>

<script>

export default {
    name: 'UsersForm',
    props: ['title', 'formData', 'formError', 'aclGroups', 'status', 'newuser', 'company'],
    methods:
  {
      saveRow(formData)
      {
          const me = this;
          me.$emit('saveRow', formData);
      },
  },
};
</script>
